<template>
	<DropdownCustom ref="dropdownCustom" :toggleIcon="false" equalWidth>
		<div class="show-content">
			<span @click.stop="beforePeriod"><i class="fa fa-caret-left"></i></span>
			<span>{{displayText}}</span>
			<span @click.stop="afterPeriod"><i class="fa fa-caret-right"></i></span>
		</div>
		<div class="accountDateRangeChoose" slot="content">
			<div class="range-picker">
				<div class="range-row">
					<span class="range-label">起始期间：</span>
					<select v-model="startPeriod" class="period-select" @change="updateValue">
						<option v-for="item in availablePeriods" :key="'start-'+item.value" :value="item.value">{{item.label}}</option>
					</select>
				</div>
				<div class="range-row">
					<span class="range-label">结束期间：</span>
					<select v-model="endPeriod" class="period-select" @change="updateValue">
						<option v-for="item in availablePeriods" :key="'end-'+item.value" :value="item.value" :disabled="item.value < startPeriod">{{item.label}}</option>
					</select>
				</div>
			</div>
		</div>
	</DropdownCustom>
</template>

<script>
	import {mapState} from 'vuex'
	import moment from 'moment'

	export default {
		name: "AccountDateRangeChoose",
		props: {
			value: Object, // {startDate: '', endDate: ''}
		},
		computed: {
			...mapState(['currentAccountSets', 'User']),
			checkDateObject() {
				let data = {};
				this.User.checkoutList.forEach(item => {
					if (!data[item.checkYear]) {
						data[item.checkYear] = [];
					}
					data[item.checkYear].push(item.checkMonth);
				});
				Object.keys(data).forEach((value) => {
					data[value] = data[value].sort((a, b) => a - b);
				});
				return data;
			},
			availablePeriods() {
				let periods = [];
				let years = Object.keys(this.checkDateObject).sort((a, b) => b - a);
				years.forEach(year => {
					this.checkDateObject[year].forEach(month => {
						periods.push({
							value: `${year}-${String(month).padStart(2, '0')}`,
							label: `${year}年第${month}期`,
							year: parseInt(year),
							month: month
						});
					});
				});
				return periods;
			},
			displayText() {
				if (!this.startPeriod || !this.endPeriod) {
					return '请选择期间';
				}
				if (this.startPeriod === this.endPeriod) {
					let parts = this.startPeriod.split('-');
					return `${parts[0]}年第${parseInt(parts[1])}期`;
				}
				let startParts = this.startPeriod.split('-');
				let endParts = this.endPeriod.split('-');
				return `${startParts[0]}.${startParts[1]}-${endParts[0]}.${endParts[1]}`;
			}
		},
		data() {
			return {
				startPeriod: null,
				endPeriod: null
			}
		},
		watch: {
			value: {
				handler(val) {
					if (val && val.startDate && val.endDate) {
						this.startPeriod = moment(val.startDate).format('YYYY-MM');
						this.endPeriod = moment(val.endDate).format('YYYY-MM');
					}
				},
				immediate: true
			}
		},
		methods: {
			updateValue() {
				if (this.startPeriod && this.endPeriod && this.startPeriod <= this.endPeriod) {
					let [startYear, startMonth] = this.startPeriod.split('-');
					let [endYear, endMonth] = this.endPeriod.split('-');
					this.$emit('input', {
						startDate: moment({years: startYear, months: startMonth - 1, days: 1}).startOf('month').format('YYYY-MM-DD'),
						endDate: moment({years: endYear, months: endMonth - 1, days: 1}).endOf('month').format('YYYY-MM-DD'),
						startYear: parseInt(startYear),
						startMonth: parseInt(startMonth),
						endYear: parseInt(endYear),
						endMonth: parseInt(endMonth)
					});
				}
			},
			beforePeriod() {
				let periods = this.availablePeriods;
				let startIndex = periods.findIndex(p => p.value === this.startPeriod);
				if (startIndex > 0) {
					this.startPeriod = periods[startIndex - 1].value;
					this.endPeriod = periods[startIndex - 1].value;
					this.updateValue();
				}
			},
			afterPeriod() {
				let periods = this.availablePeriods;
				let endIndex = periods.findIndex(p => p.value === this.endPeriod);
				if (endIndex < periods.length - 1) {
					this.startPeriod = periods[endIndex + 1].value;
					this.endPeriod = periods[endIndex + 1].value;
					this.updateValue();
				}
			}
		},
		mounted() {
			if (this.availablePeriods.length > 0) {
				let current = this.availablePeriods[0].value;
				this.startPeriod = current;
				this.endPeriod = current;
				this.updateValue();
			}
		}
	}
</script>

<style lang="less">
	.show-content {
		background: @primary-color;
		color: @white-color;
		cursor: pointer;
		border-radius: @border-radius;

		span {
			padding: 5px 10px;
			display: inline-block
		}
	}

	.accountDateRangeChoose {
		padding: 10px;
		
		.range-picker {
			.range-row {
				display: flex;
				align-items: center;
				margin-bottom: 8px;
				
				&:last-child {
					margin-bottom: 0;
				}
				
				.range-label {
					width: 70px;
					flex-shrink: 0;
				}
				
				.period-select {
					flex: 1;
					padding: 5px 10px;
					border: 1px solid #ddd;
					border-radius: 4px;
					cursor: pointer;
					
					&:focus {
						outline: none;
						border-color: @primary-color;
					}
				}
			}
		}
	}
</style>
